// Fearlessly Hue® theme JS — progressive enhancement only. Every control
// this file touches (mega-menu <details>, mobile nav, search panel)
// already works with plain HTML/CSS if this file fails to load; JS only
// adds hover-to-open on desktop and click-outside/Escape-to-close.
// No framework, no bundler — matches "minimal JavaScript overhead."
(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // --- Mega-menu: hover-to-open on desktop (pointer: fine), native
  // <details> click/keyboard behavior is untouched and always available. ---
  function initMegaMenu() {
    var megas = document.querySelectorAll("[data-fh-mega]");
    var hoverCapable = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (!hoverCapable) return; // touch devices keep plain tap-to-open <details>

    megas.forEach(function (details) {
      var closeTimer = null;
      details.addEventListener("mouseenter", function () {
        clearTimeout(closeTimer);
        megas.forEach(function (d) { if (d !== details) d.open = false; });
        details.open = true;
      });
      details.addEventListener("mouseleave", function () {
        closeTimer = setTimeout(function () { details.open = false; }, 150);
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") megas.forEach(function (d) { d.open = false; });
    });
  }

  // --- Mobile nav drawer ---
  function initMobileNav() {
    var trigger = document.querySelector("[data-fh-mobile-nav-trigger]");
    var closeBtn = document.querySelector("[data-fh-mobile-nav-close]");
    var drawer = document.querySelector("[data-fh-mobile-nav]");
    if (!trigger || !drawer) return;

    function open() {
      drawer.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      var firstFocusable = drawer.querySelector("a, button");
      if (firstFocusable) firstFocusable.focus();
      document.body.style.overflow = "hidden";
    }
    function close() {
      drawer.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      trigger.focus();
      document.body.style.overflow = "";
    }
    trigger.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !drawer.hidden) close();
    });
  }

  // --- Search panel ---
  function initSearchPanel() {
    var trigger = document.querySelector("[data-fh-search-trigger]");
    var closeBtn = document.querySelector("[data-fh-search-close]");
    var panel = document.querySelector("[data-fh-search-panel]");
    if (!trigger || !panel) return;

    function open() {
      panel.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      var input = panel.querySelector("input[type=search]");
      if (input) input.focus();
    }
    function close() {
      panel.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      trigger.focus();
    }
    trigger.addEventListener("click", function () {
      panel.hidden ? open() : close();
    });
    if (closeBtn) closeBtn.addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !panel.hidden) close();
    });
  }

  // --- Quick Add: submit via fetch, update the cart count without a full
  // page reload, restore the button label either way. Falls back to a
  // normal form POST (full page reload to /cart) if fetch fails. ---
  // --- Cart drawer: real Shopify Ajax Cart API (/cart.js, /cart/change.js)
  // — every render reflects a real fetch, never a guessed/optimistic
  // local state. The drawer element and its <template>s live in
  // snippets/fh-cart-drawer.liquid; this is purely behavior on top of
  // real markup that already exists in the DOM. The cart icon's plain
  // <a href> keeps working as a real link the whole time — this only
  // intercepts the click when JS is available. ---
  var FhCart = (function () {
    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    }

    function fetchCart() {
      return fetch(root() + "cart.js").then(function (res) { return res.json(); });
    }

    function money(cents) {
      return "$" + (cents / 100).toFixed(2);
    }

    function renderCart(cart) {
      var body = document.querySelector("[data-fh-cart-body]");
      // An error reply has no items; clearing first left the drawer blank (Dana, 2026-11-02, 15+ canvases).
      if (!body || !cart || !Array.isArray(cart.items)) return;
      body.innerHTML = "";

      if (!cart.items.length) {
        var emptyTpl = document.getElementById("fh-cart-empty-template");
        if (emptyTpl) body.appendChild(emptyTpl.content.cloneNode(true));
        return;
      }

      var lineTpl = document.getElementById("fh-cart-line-template");
      cart.items.forEach(function (item) {
        var node = lineTpl.content.cloneNode(true);
        var links = node.querySelectorAll("[data-fh-line-href]");
        links.forEach(function (a) { a.href = item.url; });
        var img = node.querySelector("[data-fh-line-image]");
        if (img && item.image) { img.src = item.image; img.alt = item.product_title || ""; }
        var title = node.querySelector("[data-fh-line-title]");
        if (title) title.textContent = item.product_title;
        var variant = node.querySelector("[data-fh-line-variant]");
        if (variant) variant.textContent = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
        var qty = node.querySelector("[data-fh-line-qty]");
        if (qty) qty.textContent = item.quantity;
        var price = node.querySelector("[data-fh-line-price]");
        if (price) price.textContent = money(item.final_line_price);
        var lineEl = node.querySelector("[data-fh-cart-line]");
        if (lineEl) lineEl.setAttribute("data-key", item.key);
        body.appendChild(node);
      });

      var footerTpl = document.getElementById("fh-cart-footer-template");
      var footerNode = footerTpl.content.cloneNode(true);
      var subtotalEl = footerNode.querySelector("[data-fh-cart-subtotal]");
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
      body.appendChild(footerNode);
    }

    function refresh() {
      return fetchCart().then(function (cart) {
        renderCart(cart);
        document.querySelectorAll("[data-fh-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle("fh-visually-hidden", cart.item_count === 0);
        });
        return cart;
      });
    }

    function open() {
      var drawer = document.querySelector("[data-fh-cart-drawer]");
      var trigger = document.querySelector("[data-fh-cart-icon]");
      if (!drawer) return;
      drawer.hidden = false;
      if (trigger) trigger.setAttribute("aria-expanded", "true");
      refresh();
      var closeBtn = drawer.querySelector("[data-fh-cart-close]");
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      var drawer = document.querySelector("[data-fh-cart-drawer]");
      var trigger = document.querySelector("[data-fh-cart-icon]");
      if (!drawer) return;
      drawer.hidden = true;
      if (trigger) { trigger.setAttribute("aria-expanded", "false"); trigger.focus(); }
    }

    // `line` is the 1-based line number. A line's key changes when a discount
    // (the 3-canvas 20%) starts or stops applying, so a key read before the
    // last change can be stale; the line number is not. The drawer always
    // re-reads /cart.js afterwards: change.js's own total_price came back
    // wrong with the 20% applied (4 canvases: 202.76 against a real 176.00,
    // 2026-11-02), and a failed reply must not blank the drawer.
    function changeLine(line, quantity) {
      return fetch(root() + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(refresh, refresh);
    }

    return { open: open, close: close, refresh: refresh, changeLine: changeLine, renderCart: renderCart, root: root };
  })();

  function initCartDrawer() {
    var drawer = document.querySelector("[data-fh-cart-drawer]");
    var trigger = document.querySelector("[data-fh-cart-icon]");
    if (!drawer || !trigger) return;

    trigger.addEventListener("click", function (e) {
      e.preventDefault(); // the real cart page (trigger.href) is the no-JS fallback; JS opens the drawer instead
      FhCart.open();
    });
    var closeBtn = drawer.querySelector("[data-fh-cart-close]");
    if (closeBtn) closeBtn.addEventListener("click", FhCart.close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !drawer.hidden) FhCart.close();
    });

    // Event delegation: cart lines are rendered dynamically, so listen on
    // the body container rather than attaching per-line handlers.
    var body = drawer.querySelector("[data-fh-cart-body]");
    if (body) {
      body.addEventListener("click", function (e) {
        var lineEl = e.target.closest("[data-fh-cart-line]");
        if (!lineEl) return;
        var line = Array.prototype.indexOf.call(body.querySelectorAll("[data-fh-cart-line]"), lineEl) + 1;
        var qtyEl = lineEl.querySelector("[data-fh-line-qty]");
        var current = parseInt(qtyEl.textContent, 10);
        if (e.target.closest("[data-fh-line-remove]")) {
          FhCart.changeLine(line, 0);
          return;
        }
        var next;
        if (e.target.closest("[data-fh-qty-increase]")) next = current + 1;
        else if (e.target.closest("[data-fh-qty-decrease]")) next = Math.max(0, current - 1);
        else return;
        // Show the new number at once and send one change after the taps stop,
        // so fast tapping is one request, not several racing each other.
        qtyEl.textContent = next;
        clearTimeout(lineEl.fhQtyTimer);
        lineEl.fhQtyTimer = setTimeout(function () { FhCart.changeLine(line, next); }, 350);
      });
    }
  }

  function initQuickAdd() {
    document.querySelectorAll("[data-fh-quick-add]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var button = form.querySelector("button[type=submit]");
        var label = form.querySelector("[data-fh-quick-add-label]");
        var originalText = label ? label.textContent : "";
        if (label) label.textContent = "Adding…";
        if (button) button.disabled = true;

        fetch(FhCart.root() + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: form.querySelector("[name=id]").value, quantity: 1 }] }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error("Add to cart failed");
            return FhCart.refresh();
          })
          .then(function () {
            FhCart.open();
            if (label) label.textContent = "Added ✓";
            setTimeout(function () {
              if (label) label.textContent = originalText;
              if (button) button.disabled = false;
            }, 1500);
          })
          .catch(function () {
            // Real fallback, not a silent failure: a normal form submit still adds the item.
            HTMLFormElement.prototype.submit.call(form);
          });
      });
    });
  }

  // --- Product page: variant picker + gallery thumbnails. The <select>
  // elements and thumbnail <button>s all work with zero JS (a select
  // defaults to its first/selected option; a thumbnail button without a
  // click handler just does nothing, never breaks the page) — this only
  // adds the "compute the real matching variant and update price/
  // availability/main image" behavior on top. ---
  function initProductForm() {
    var section = document.querySelector("[data-fh-product-main]");
    if (!section) return;
    var product;
    try {
      product = JSON.parse(section.getAttribute("data-product-json"));
    } catch (e) {
      return; // malformed data — the plain <select>s and form still submit normally to /cart/add
    }

    var selects = Array.prototype.slice.call(section.querySelectorAll("[data-fh-option-select]"));
    var variantIdInput = section.querySelector("[data-fh-variant-id]");
    var priceAmount = section.querySelector("[data-fh-price-amount]");
    var priceCompare = section.querySelector("[data-fh-price-compare]");
    var availability = section.querySelector("[data-fh-availability]");
    var addButton = section.querySelector("[data-fh-add-to-cart]");
    var addLabel = section.querySelector("[data-fh-add-label]");
    var mainImage = document.getElementById("fh-product-main-image");

    function currentOptionValues() {
      return selects.map(function (s) { return s.value; });
    }

    function findMatchingVariant(values) {
      return product.variants.find(function (v) {
        var vOptions = [v.option1, v.option2, v.option3].filter(function (x) { return x !== null && x !== undefined; });
        return values.every(function (val, i) { return vOptions[i] === val; });
      });
    }

    function formatMoney(cents) {
      // Real, verified live 2026-09-02 (not assumed): `product | json` in
      // Liquid serializes variant prices as raw NUMBERS IN CENTS (e.g.
      // 2900 for $29.00), the same convention as the Ajax cart API — NOT
      // a "29.00" major-units string. Confirmed by testing the actual
      // variant picker against a real product and seeing "$2900.00"
      // before this fix.
      var n = typeof cents === "string" ? parseFloat(cents) : cents;
      return "$" + (n / 100).toFixed(2);
    }

    function applyVariant(variant) {
      if (!variant) {
        if (availability) { availability.textContent = "This combination is not available"; }
        if (addButton) { addButton.setAttribute("disabled", "disabled"); }
        if (addLabel) { addLabel.textContent = "Unavailable"; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceAmount) priceAmount.textContent = formatMoney(variant.price);
      if (priceCompare) {
        if (variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
      if (availability) availability.textContent = variant.available ? "In stock" : "Sold out";
      if (addButton) {
        if (variant.available) { addButton.removeAttribute("disabled"); } else { addButton.setAttribute("disabled", "disabled"); }
      }
      if (addLabel) addLabel.textContent = variant.available ? "Add to Cart" : "Sold Out";
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src;
      }
    }

    selects.forEach(function (select) {
      select.addEventListener("change", function () {
        applyVariant(findMatchingVariant(currentOptionValues()));
      });
    });

    // Thumbnails: swap the main image, never navigate/submit anything.
    section.querySelectorAll("[data-fh-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!mainImage) return;
        mainImage.src = thumb.getAttribute("data-full-src");
        var srcset = thumb.getAttribute("data-full-srcset");
        if (srcset) mainImage.srcset = srcset;
        section.querySelectorAll("[data-fh-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });

    // Real Ajax add-to-cart with drawer feedback, same pattern as Quick
    // Add. The form's real action (/cart/add via {% form 'product' %})
    // stays the no-JS fallback — a normal POST + full page reload still
    // adds the item correctly if this fetch fails for any reason.
    var form = section.querySelector("#fh-product-form");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var addBtn = form.querySelector("[data-fh-add-to-cart]");
        var addLbl = form.querySelector("[data-fh-add-label]");
        var original = addLbl ? addLbl.textContent : "";
        if (addLbl) addLbl.textContent = "Adding…";
        if (addBtn) addBtn.disabled = true;
        var formData = new FormData(form);

        fetch(FhCart.root() + "cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || "Add to cart failed"); });
            return FhCart.refresh();
          })
          .then(function () {
            FhCart.open();
            if (addLbl) addLbl.textContent = "Added ✓";
            setTimeout(function () {
              if (addLbl) addLbl.textContent = original;
              if (addBtn) addBtn.disabled = false;
            }, 1500);
          })
          .catch(function () {
            // Real fallback: a normal form submit still adds the item and
            // shows Shopify's own real error state if the variant is
            // genuinely unavailable, rather than a silently-stuck button.
            HTMLFormElement.prototype.submit.call(form);
          });
      });
    }
  }

  // --- Keep Exploring: fetch Shopify's real recommendations for this
  // product and swap them into the empty shell. Real, documented Shopify
  // pattern (recommendations must be fetched async — Liquid can't
  // compute them on the normal page render). If the fetch fails, the
  // section simply stays empty rather than showing anything invented. ---
  function initProductRecommendations() {
    var section = document.querySelector("[data-fh-recommendations]");
    if (!section) return;
    var url = section.getAttribute("data-url");
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var rendered = doc.querySelector("[data-fh-recommendations]");
        if (rendered && rendered.innerHTML.trim()) {
          section.innerHTML = rendered.innerHTML;
        }
      })
      .catch(function () {
        // Leave the section empty — no fallback content is invented here.
      });
  }

  // --- Personalize button placement: Printify's real "Add personalized
  // design" app block renders as its own standalone section elsewhere
  // in the page (theme/templates/product.json's "apps" section), not
  // as part of this theme's product form. Real Dana feedback
  // 2026-09-03, in three steps: "put it above the add to card line" ->
  // "Also above the in stock line" -> "Under the size" — i.e. right
  // after the size/option selector, before availability and Add to
  // Cart (see [data-fh-personalize-slot] in fh-product-main.liquid).
  // Moves the app's OWN already-rendered DOM node into that slot,
  // rather than relocating its block data between sections in the JSON
  // (which would risk breaking whatever internal reference the app's
  // own script keeps to its block/section id) — same element, same
  // ids, same event listeners, just repositioned visually. Only acts
  // when BOTH a real .personalize-container (Printify's own stable
  // class — not guessed) and the real slot exist, so a product without
  // this app block is untouched, and a future, different app's block
  // is never accidentally swept up by a generic app-block selector. ---
  function initPersonalizeButton() {
    var slot = document.querySelector("[data-fh-personalize-slot]");
    var container = document.querySelector(".personalize-container");
    if (!slot || !container) return;
    var appBlock = container.closest(".shopify-block") || container;
    var section = appBlock.closest(".shopify-section");
    slot.appendChild(appBlock);
    // The app's own section shell is now empty (this build never puts
    // anything else in it) — hide it so it doesn't leave a stray empty
    // element in the page.
    if (section && section.children.length === 0) section.hidden = true;
  }

  // --- Collection page: mobile filter drawer, sort auto-submit, and
  // instant-navigate filter checkboxes. Every piece here has a real,
  // working fallback without JS: the drawer trigger/checkboxes are plain
  // <button>/<input> that submit the surrounding <form method="get">
  // normally; sort has a real submit button too. ---
  function initCollectionFilters() {
    var trigger = document.querySelector("[data-fh-filter-trigger]");
    var closeBtn = document.querySelector("[data-fh-filter-close]");
    var drawer = document.querySelector("[data-fh-filter-drawer]");
    if (trigger && drawer) {
      trigger.addEventListener("click", function () {
        drawer.hidden = false;
        trigger.setAttribute("aria-expanded", "true");
        var firstInput = drawer.querySelector("input, a, button");
        if (firstInput) firstInput.focus();
      });
      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          drawer.hidden = true;
          trigger.setAttribute("aria-expanded", "false");
          trigger.focus();
        });
      }
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !drawer.hidden) {
          drawer.hidden = true;
          trigger.setAttribute("aria-expanded", "false");
        }
      });
    }

    var sortSelect = document.querySelector("[data-fh-sort-select]");
    if (sortSelect) {
      sortSelect.addEventListener("change", function () {
        sortSelect.closest("form").submit();
      });
    }

    document.querySelectorAll("[data-fh-filter-checkbox]").forEach(function (checkbox) {
      checkbox.addEventListener("change", function () {
        var url = checkbox.checked ? checkbox.getAttribute("data-url-add") : checkbox.getAttribute("data-url-remove");
        if (url) window.location.href = url;
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMegaMenu();
    initMobileNav();
    initSearchPanel();
    initCartDrawer();
    initQuickAdd();
    initProductForm();
    initPersonalizeButton();
    initProductRecommendations();
    initCollectionFilters();
  });
})();
